import axios from "@/api/axios";
import qs from "qs";

const memberList = async (param, result) => {
  console.log("param", param);
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: "1",
    pagesize: 10,
    playerlistcnt: "0",
    playerlist: [
      {
        no: 0,
        id: "",
        nickname: "",
        name: "",
        email: "",
        playcnt: "",
        avgshot: "",
        lastdate: "",
        joindate: "",
        playerno: "",
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/membership/playerlist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    params: param,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const memberGet = async (no, result) => {
  let finalData = {
    playerinfo: {
      no: 0,
      id: "",
      nickname: "",
      name: "",
      email: "",
      playcnt: "",
      avgshot: "",
      lastdate: "",
      regdate: "",
      playerno: "",
    },
  };
  const options = {
    method: "GET",
    url: "/membership/playerinfo/" + no,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data.playerinfo;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const memberSave = async (playerNo, form, result) => {
  let finalData = {
    code: 0,
    message: "",
  };

  const options = {
    method: "POST",
    url: "/membership/playerwrite/" + playerNo,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify({
      lockerno: form.lockerno,
      lockersdate: form.lockersdate,
      lockeredate: form.lockeredate,
      point: form.point,
      memo: form.memo,
    }),
    // params: {}
  };
  await axios(options).then((response) => {
    // alert(response.data.code);
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const sendEmail = async (sendData, result) => {
  let finalData = {
    code: 0,
    message: "",
  };

  const options = {
    method: "POST",
    url: "/membership/playeremailsend",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(sendData),
    //params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const excelSave = async (param, result) => {
  let finalData = {
    code: 0,
    message: "",
  };
  const options = {
    method: "GET",
    url: "/membership/playerlist/excel",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //data: qs.stringify({})
    params: param,
  };

  await axios(options).then((response) => {
    // alert(response.headers["content-disposition"]);
    // console.log(response);
    //  let header = response.headers["Content-Disposition"];

    // let filenameTmp = header.split("=");
    // let filename = filenameTmp[1];
    // let filename = "member_". date("Y-m-d") .".xls";

    result(response.data);
  });
};

const pointList = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: "1",
    pagesize: 10,
    pointlistcnt: "0",
    pointlist: [],
  };
  const options = {
    method: "GET",
    url: "/membership/pointlist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    params: param,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const addPoint = async (sendData, result) => {
  let finalData = {
    code: 0,
    message: "",
  };

  const options = {
    method: "POST",
    url: "/membership/addpoint",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(sendData),
    //params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const removePoint = async (sendData, result) => {
  let finalData = {
    code: 0,
    message: "",
  };

  const options = {
    method: "POST",
    url: "/postact/removepoint",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(sendData),
    //params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const lockerGet = async (no, pageno, result) => {
  let finalData = {
    lockerinfocnt: 0,
    lockerinfo: [
      {
        no: 1,
        lockerno: "1",
        lockerstatus: "1",
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/membership/playerlockerinfo/" + no + "/" + 1,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    params: { pageno: pageno },
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData.lockerinfocnt = response.data.lockerinfocnt;
      finalData.lockerinfo = response.data.lockerinfo;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const lockerGet2 = async (pageno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: "1",
    pagesize: 30,
    lockerinfocnt: "0",
    lockerinfo: [
      {
        no: 1,
        lockerno: "0",
        lockerstatus: "1",
        nickname: "",
        enddate: "",
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/membership/playerlockerlist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    params: { pageno: pageno },
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const lockerStatus = async (lockerno, status, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "PUT",
    url: "/postact/playerlockerchangeinfo/" + lockerno + "/" + status,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};

export default {
  memberList,
  memberGet,
  memberSave,
  sendEmail,
  excelSave,
  pointList,
  addPoint,
  removePoint,
  lockerGet,
  lockerGet2,
  lockerStatus,
};
